import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { auth, googleProvider } from '../firebase';

const AuthContext = createContext();
const API = process.env.REACT_APP_API_URL || '';

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session from localStorage on mount (no Firebase involved)
  useEffect(() => {
    const token = localStorage.getItem('sc_token');
    if (token) {
      axios.get(`${API}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('sc_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('sc_token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('sc_token');
    setUser(null);
  };

  const signInWithGoogle = async (preferred_lang = 'en') => {
    const { signInWithPopup } = await import('firebase/auth');
    if (!auth || !googleProvider) throw new Error('Google sign-in not available');
    const result = await signInWithPopup(auth, googleProvider);
    const idToken = await result.user.getIdToken();
    const { data } = await axios.post(`${API}/api/auth/firebase`, {
      id_token: idToken,
      preferred_lang,
    });
    login(data.access_token, data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      isAuthenticated: !!user,
      isPro: user?.plan === 'pro',
      token: localStorage.getItem('sc_token'),
      login,
      logout,
      signInWithGoogle,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthContext;
